export default class FileUploadFailedRequest {
    public fileName: string = "";

    public statusCode: string = "";

    public message: string = "";
}